import { create } from 'zustand';

type TDevice = 'phone' | 'pad' | 'pc';

interface ISessionConfig {
  nickId: string;
  sessionId: string;
  token: string;
  uid: string;
}

interface IAppStore {
  curDevice: TDevice;
  setCurDevice: () => any;
  sessionConfig: ISessionConfig;
  isKickOff: boolean;
  setIsKickOff: () => any;
}

const useAppStore = create<IAppStore>((set, get) => ({
  curDevice: 'pad',
  sessionConfig: {
    nickId: '',
    sessionId: '',
    token: '',
    uid: '',
  },
  isKickOff: false,
  setCurDevice: () =>
    set(() => {
      const clientWidth = window.innerWidth;
      if (clientWidth <= 750) {
        return { curDevice: 'phone' };
      } else if (clientWidth <= 1280 && clientWidth > 750) {
        return { curDevice: 'pad' };
      } else {
        return { curDevice: 'pc' };
      }
    }),

  setSessionConfig: (sessionConfig: ISessionConfig) =>
    set((prev) => {
      return { sessionConfig };
    }),

  setIsKickOff: () =>
    set((prev) => {
      return { isKickOff: true };
    }),
}));

export default useAppStore;
